import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { plazaServices } from "./pages/tollPlaza/plazaReportService";
import { useHistory } from "react-router-dom";
import * as XLSX from "xlsx";
import { useRef } from "react";
import { useSelector } from "react-redux";
import imagineHomeService from "./pages/imagineHome/imagineHomeService";
import { Dialog } from "primereact/dialog";
import { Galleria } from "primereact/galleria";
import ObjMtlViewer from "./components/ModelViewer";

import { TabView, TabPanel } from "primereact/tabview";
import { superAdmin } from "./lib/constants";

const ProductCatalogue = () => {
    const [products, setProducts] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});
    const [item, setItem] = useState(null);
    const [vendor, setVendor] = useState("All");
    const [editRows, setEditRows] = useState({});
    const [admin, setAdmin] = useState(false);
    const [skip, setSkip] = useState(0);
    const [first, setFirst] = useState(0);
    const serviceId = localStorage.getItem("serviceId");
    const history = useHistory();
    const isInitialRender = useRef(true);
    const [userVendors, setUserVendors] = useState([]);
    const { usersVendors } = useSelector((state) => state.usersVendors);
    const [mediaDialogVisible, setMediaDialogVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(0);
    const [downloadingMedia, setDownloadingMedia] = useState(false);

    const mediaCacheRef = useRef({}); // cache per productId

    const responsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 5,
        },
        {
            breakpoint: "960px",
            numVisible: 4,
        },
        {
            breakpoint: "768px",
            numVisible: 3,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
        },
    ];
    const catalogLimit = 20,
        rows = 10;

    // const exportToExcel = async (e) => {
    //     e.currentTarget.blur();
    //     let reqObj = {};
    //     if (item) {
    //         reqObj["itemName"] = { $regex: `^${item}`, $options: "i" };
    //     }
    //     // if (vendor && vendor !== "All") reqObj['vendor'] = vendor;
    //     if (vendor && vendor !== "All") {
    //         reqObj["vendor"] = vendor;
    //     } else {
    //         if (userVendors.length > 0) {
    //             reqObj["vendor"] = { $in: [...userVendors] };
    //         }
    //     }
    //     let query = {
    //         filter: {
    //             ...reqObj,
    //         },
    //         sort: [["updated_ts", -1]],
    //     };
    //     let Products = await plazaServices.general(serviceId, query, "nq-product-catelogue");
    //     let columnOrder = ["vendor", "itemName", "sku", "itemDesc", "msrp", "upc"];
    //     columnOrder = [...columnOrder, "overallDimensions", "height", "width", "depth", "materials", "color", "availableFinish", "backing", "construction", "design", "collection", "countryMade", "map", "imageUrl"];
    //     const mappedProducts = Products.map((product) => ({
    //         vendor: product.vendor || "",
    //         itemName: product.itemName || "",
    //         sku: product.sku || "",
    //         itemDesc: product.itemDesc || "",
    //         msrp: product.msrp || "",
    //         wholesalePrice: product.wholesalePrice || "",
    //         upc: product.upc || "", // Conditionally map `upc`
    //         overallDimensions: product.overallDimensions || "",
    //         height: product.height || "",
    //         width: product.width || "",
    //         depth: product.depth || "",
    //         materials: product.materials || "",
    //         color: product.color || "",
    //         availableFinish: product.availableFinish || "",
    //         backing: product.backing || "",
    //         construction: product.construction || "",
    //         design: product.design || "",
    //         collection: product.collection || "",
    //         countryMade: product.countryMade || "",
    //         map: product.map || "",
    //         imageUrl: product.imageUrl || "",
    //     }));
    //     const worksheet = XLSX.utils.json_to_sheet(mappedProducts, { header: columnOrder });
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Product Catalogue");
    //     XLSX.writeFile(workbook, "Product_Catalogue.xlsx");
    // };
    const exportToExcel = async (e) => {
        e.currentTarget.blur();
        let Products;
        const res = await imagineHomeService.fetchProductCatalogues(createPayload(serviceId, userVendors, false, 0));
        if (res && res.status === 200) {
            Products = res.data;
        } else return;

        let columnOrder = ["vendor", "itemName", "sku", "itemDesc", "msrp", "upc"];
        columnOrder = [...columnOrder, "overallDimensions", "height", "width", "depth", "materials", "color", "availableFinish", "backing", "construction", "design", "collection", "countryMade", "map", "imageUrl"];
        const mappedProducts = Products.map((product) => ({
            vendor: product.vendor || "",
            itemName: product.itemName || "",
            sku: product.sku || "",
            itemDesc: product.itemDesc || "",
            msrp: product.msrp || "",
            wholesalePrice: product.wholesalePrice || "",
            upc: product.upc || "", // Conditionally map `upc`
            overallDimensions: product.overallDimensions || "",
            height: product.height || "",
            width: product.width || "",
            depth: product.depth || "",
            materials: product.materials || "",
            color: product.color || "",
            availableFinish: product.availableFinish || "",
            backing: product.backing || "",
            construction: product.construction || "",
            design: product.design || "",
            collection: product.collection || "",
            countryMade: product.countryMade || "",
            map: product.map || "",
            imageUrl: product.imageUrl || "",
        }));
        const worksheet = XLSX.utils.json_to_sheet(mappedProducts, { header: columnOrder });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Product Catalogue");
        XLSX.writeFile(workbook, "Product_Catalogue.xlsx");
    };
    const makeQuery = (skipCount = 0, vendors) => {
        let reqObj = {};
        if (item) {
            reqObj["itemName"] = { $regex: `^${item}`, $options: "i" };
        }
        if (vendor && vendor !== "All") {
            reqObj["vendor"] = vendor;
        } else {
            if (vendors.length > 0) {
                reqObj["vendor"] = { $in: [...vendors] };
            }
        }
        let query = {
            filter: {
                ...reqObj,
            },
            skip: skipCount,
            limit: 15,
            sort: [["updated_ts", -1]],
        };
        return query;
    };
    const createPayload = (serviceId, vendors, includeMediaURL, skipCount, limit) => {
        let selectedVendors = [];
        if (vendor && vendor !== "All") {
            selectedVendors.push(vendor);
        } else {
            if (vendors.length > 0) {
                selectedVendors = vendors;
            }
        }
        let payload = {
            serviceId,
            vendorSearch: selectedVendors,
            productSearch: item ? item : undefined,
            includeMediaURL,
            limit: limit,
            offset: skipCount && skipCount >= 0 ? skipCount : limit ? 0 : undefined,
        };
        return payload;
    };

    const fetchData = async () => {
        try {
            let email = localStorage.getItem("emailId");
            const userResponse = await plazaServices.general("imaginehome_master_db", { filter: { "user.email": email } }, "nq-userpermissions");

            let usersVendorsData = userResponse[0].user?.catalogAccess?.filter((v) => v !== "") ?? [];
            const vendorResponse = await plazaServices.general(serviceId, {}, "nq-products-vendors");
            let uv = vendorResponse.filter((v) => usersVendorsData.includes(v.vendorID)).map((v) => v.name);
            setUserVendors(uv);
            let formattedVendors = [];
            if (usersVendorsData.length > 0) {
                setVendors(vendorResponse.filter((v) => usersVendorsData.includes(v.vendorID)));
                formattedVendors = vendorResponse.filter((v) => usersVendorsData.includes(v.vendorID)).map((v) => ({ label: v.name, value: v.name }));
            } else {
                setVendors(vendorResponse);
                formattedVendors = vendorResponse.map((v) => ({ label: v.name, value: v.name }));
            }
            const tempArray = [{ label: "All", value: "All" }];
            const combinedVendors = [...tempArray, ...formattedVendors];
            setVendorList(combinedVendors);

            const res = await imagineHomeService.fetchProductCatalogues(createPayload(serviceId, uv, true, 0, catalogLimit));
            if (res && res.status === 200) {
                setProducts([...res.data]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        let array = JSON.parse(localStorage.getItem("permissions"))??[];
        if (array.includes(superAdmin)) setAdmin(true);
        fetchData();
    }, []);

    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            setFirst(0);
            setSkip(0);
            setProducts([]);
            handleFilter(0);
        }, 1000);

        return () => clearTimeout(timer); // Cleanup to avoid multiple calls
    }, [item, vendor]);

    const handleFilter = async (skipCount) => {
        setLoading(true);
        try {
            const res = await imagineHomeService.fetchProductCatalogues(createPayload(serviceId, userVendors, true, skipCount, catalogLimit));
            if (res && res.status === 200) {
                if (res.data.length < catalogLimit) setSkip(-1);
                setProducts((prev) => {
                    const merged = [...prev, ...res.data];
                    return merged;
                });
            }
        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };

    const toggleRowExpansion = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const itemDescTemplate = (row) => {
        const description = row.itemDesc || ""; // Ensure it's a string
        const isExpanded = expandedRows[row.itemName];
        const shortDesc = description.slice(0, 50);
        const isLong = description.length > 100;

        return (
            <div style={{ width: `20rem` }} className="">
                {isExpanded ? description : shortDesc}
                {isLong && (
                    <span className="text-blue-500 cursor-pointer ml-2" onClick={() => toggleRowExpansion(row.itemName)}>
                        {isExpanded ? "Show Less" : "Show More"}
                    </span>
                )}
            </div>
        );
    };

    const GalleryTemplate = () => {
        return (
            <Galleria
                className="my-galleria"
                value={selectedProduct.formattedImages}
                responsiveOptions={responsiveOptions}
                numVisible={1}
                showThumbnails={false}
                showIndicators={selectedProduct.formattedImages?.length > 1}
                showItemNavigators={selectedProduct.formattedImages?.length > 1}
                showItemNavigatorsOnHover={false} // keep arrows always visible
                circular
                style={{ maxWidth: "100%", textAlign: "center" }}
                item={(item) => <img src={item.itemImageSrc} alt={selectedProduct.itemName} style={{ width: "100%", height: "400px", objectFit: "contain" }} />}
            />
        );
    };
    const findVendorUrl = (name) => {
        return vendors.find((v) => v.name.toLowerCase() === name.toLowerCase())?.websiteURL || "";
    };

    const has3dModel = () => {
        // return selectedProduct.glbUrl || selectedProduct.dwgUrl || (selectedProduct.objUrl && selectedProduct.mtlUrl);
        return selectedProduct.glbUrl || selectedProduct.dwgUrl;
    };

    const showData = (row, field) => {
        const key = `${row._id}`;
        const fields = ["width", "height", "depth"];

        if (field === "itemDesc" && !editRows[key]) {
            return itemDescTemplate(row);
        } else if (editRows[key]) {
            return <InputText value={row[field]} icon />;
        } else if (field === "images") {
            const images = row[field] || undefined;
            // const has3D = row["3D_model_glb_path"] || row["3D_model_dwg_path"] || (row["3D_model_obj_path"] && row["3D_model_mtl_path"]);
            const has3D = row["3D_model_glb_path"] || row["3D_model_dwg_path"] ? true : false;
            if (images && images.length > 0) {
                return (
                    <div className="flex flex-column align-items-center justify-content-center ml-3">
                        <img
                            style={{ width: "40px", height: "40px" }}
                            src={row["primary_image_url"]}
                            alt="thumbnail"
                            className={`w-16 h-16 border-round ${downloadingMedia ? "cursor-not-allowed" : "cursor-pointer"}`}
                            onClick={() => {
                                if (!downloadingMedia) handleViewMore(images, has3D, row);
                            }}
                        />

                        {images.length > 1 ? (
                            <p
                                onClick={() => {
                                    if (!downloadingMedia) handleViewMore(images, has3D, row);
                                }}

                                className={`text-blue-500 mt-2  ${downloadingMedia ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                            >
                                View More
                            </p>
                        ) : has3D ? (
                            <p
                                disabled={downloadingMedia}
                                className={`text-blue-500 mt-2 ${downloadingMedia ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                                onClick={() => {
                                    handleViewMore(images, has3D, row);
                                }}
                            >
                                View More
                            </p>
                        ) : (
                            <p
                                onClick={() => {
                                    if (!downloadingMedia) handleViewMore(images, has3D, row);
                                }}
                                className={`text-blue-500 mt-2 ${downloadingMedia ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                            >
                                View
                            </p>
                        )}
                    </div>
                );
            } else if (has3D) {
                return (
                    <p
                        href="#"
                        disabled={downloadingMedia}
                        className={`text-blue-500 text-center ${downloadingMedia ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleViewMore(images, has3D, row);
                        }}
                    >
                        View 3D Model
                    </p>
                );
            } else {
                return <p className="text-center mt-2">--</p>;
            }
        } else if (field.toLowerCase() === "vendor" || field.toLowerCase() === "itemname") {
            let url = findVendorUrl(row["vendor"]);
            if (url && url !== "") {
                return (
                    <a href={url} target="_blank" rel="noopener noreferrer" className="underline">
                        {row[field]}
                    </a>
                );
            }
            return (
                <div className={`flex align-items-center justify-content-center`}>
                    <p className="m-0 p-0">{row[field]}</p>
                </div>
            );
        } else {
            return (
                <div className={`flex align-items-center justify-content-center`}>
                    <p className="m-0 p-0">{field === "msrp" && row["msrp"] ? `$${row["msrp"]}.00` : row[field]}</p>
                    {/* {field === "vendor" && <i
                        className="pi pi-pencil text-blue-500 cursor-pointer"
                        onClick={() => handleRowClick(row, field)}
                    />} */}
                </div>
            );
        }
    };

    // const handleViewMore = async (images, has3D, row) => {
    //     setSelectedProduct(row);
    //     setDownloadingMedia(true);

    //     try {
    //         const productId = `${row.vendor}_${row.sku}`; // unique key
    //         const cached = mediaCacheRef.current[productId];

    //         let formattedImages = cached?.formattedImages || [];
    //         let objUrl = cached?.objUrl || null;
    //         let mtlUrl = cached?.mtlUrl || null;
    //         let glbUrl = cached?.glbUrl || null;
    //         let metaData = cached?.metaData || [];

    //         let fileKeys = [];

    //         // Check which URLs are missing
    //         if (has3D && ((row["3D_model_obj_path"] && row["3D_model_mtl_path"]) || row["3D_model_glb_path"])) {
    //             if (!objUrl && row["3D_model_obj_path"]) {
    //                 fileKeys.push(row["3D_model_obj_path"]);
    //             }
    //             if (!mtlUrl && row["3D_model_mtl_path"]) {
    //                 fileKeys.push(row["3D_model_mtl_path"]);
    //             }
    //             if (!glbUrl && row["3D_model_glb_path"]) {
    //                 fileKeys.push(row["3D_model_glb_path"]);
    //             }
    //             if (row["3D_model_texture_paths"] && Array.isArray(row["3D_model_texture_paths"])) {
    //                 const missingMeta = row["3D_model_texture_paths"].filter((imgPath) => !metaData.some((url) => url.includes(imgPath)));
    //                 if (missingMeta.length) {
    //                     fileKeys.push(...missingMeta);
    //                 }
    //             }
    //         }

    //         if (images?.length && !formattedImages.length) {
    //             const imageKeys = images.filter((_, i) => i !== 0).map((img) => img.path);
    //             if (imageKeys.length > 0) {
    //                 fileKeys.push(...imageKeys);
    //             }
    //              else if (row["primary_image_url"]) {
    //                 formattedImages = [{ itemImageSrc: row["primary_image_url"], thumbnailImageSrc: row["primary_image_url"] }];
    //             }
    //         } else if (!has3D && !formattedImages.length && row["primary_image_url"]) {
    //             formattedImages = [{ itemImageSrc: row["primary_image_url"], thumbnailImageSrc: row["primary_image_url"] }];
    //         }

    //         let downloadMap = {};
    //         if (fileKeys.length > 0) {
    //             const payload = {
    //                 serviceId,
    //                 fileKey: fileKeys,
    //                 source: "productCatalogue",
    //             };
    //             const res = await imagineHomeService.downloadMultipleMediaURL(payload);
    //             if (res?.download_url) {
    //                 downloadMap = res.download_url;
    //             }

    //             // Extract URLs
    //             if (row["3D_model_obj_path"] && downloadMap[row["3D_model_obj_path"]]) {
    //                 objUrl = downloadMap[row["3D_model_obj_path"]];
    //             }
    //             if (row["3D_model_mtl_path"] && downloadMap[row["3D_model_mtl_path"]]) {
    //                 mtlUrl = downloadMap[row["3D_model_mtl_path"]];
    //             }
    //             if (row["3D_model_glb_path"] && downloadMap[row["3D_model_glb_path"]]) {
    //                 glbUrl = downloadMap[row["3D_model_glb_path"]];
    //             }
    //             if (row["3D_model_texture_paths"] && Array.isArray(row["3D_model_texture_paths"])) {
    //                 metaData = row["3D_model_texture_paths"].map((imgPath) => downloadMap[imgPath] || metaData.find((url) => url.includes(imgPath))).filter(Boolean);
    //             }

    //             if (images?.length && !cached?.formattedImages) {
    //                 const extraImages = images
    //                     .filter((_, i) => i !== 0)
    //                     .map((img) => downloadMap[img.path])
    //                     .filter(Boolean)
    //                     .map((url) => ({ itemImageSrc: url, thumbnailImageSrc: url }));

    //                 formattedImages = [{ itemImageSrc: row["primary_image_url"], thumbnailImageSrc: row["primary_image_url"] }, ...extraImages];
    //             }

    //             // Save new data in cache
    //             mediaCacheRef.current[productId] = { objUrl, mtlUrl, glbUrl, formattedImages, metaData };

    //             // API was called, update selectedProduct
    //             setSelectedProduct((prev) => ({
    //                 ...prev,
    //                 formattedImages,
    //                 objUrl,
    //                 mtlUrl,
    //                 glbUrl,
    //                 metaData,
    //             }));
    //         } else {
    //             //  API not called → still update from cache
    //             setSelectedProduct((prev) => ({
    //                 ...prev,
    //                 formattedImages,
    //                 objUrl,
    //                 mtlUrl,
    //                 glbUrl,
    //                 metaData,
    //             }));
    //         }

    //         setMediaDialogVisible(true);
    //     } catch (error) {
    //         console.error("Error fetching media:", error);
    //     } finally {
    //         setDownloadingMedia(false);
    //     }
    // };

    const handleViewMore = async (images, has3D, row) => {
        setSelectedProduct(row);
        setDownloadingMedia(true);

        try {
            const productId = `${row.vendor}_${row.sku}`; // unique key
            const cached = mediaCacheRef.current[productId];
            let formattedImages = cached?.formattedImages || [];
            let objUrl = cached?.objUrl || null;
            let mtlUrl = cached?.mtlUrl || null;
            let glbUrl = cached?.glbUrl || null;
            let dwgUrl = cached?.dwgUrl || null;
            let metaData = cached?.metaData || [];
            const glbPathKey = "3D_model_glb_path",
                dwgPathKey = "3D_model_dwg_path",
                objPathKey = "3D_model_obj_path",
                mtlPathKey = "3D_model_mtl_path",
                primaryImageUrlKey = "primary_image_url",
                texturePathKey = "3D_model_texture_paths";
            const hasGLB = row[glbPathKey] ? true : false;
            const hasDWG = row[dwgPathKey] ? true : false;
            const hasOBJMTL = row[objPathKey] && row[mtlPathKey];
            let fileKeys = [];

            // Check which URLs are missing
            if (has3D) {
                if (!glbUrl && hasGLB) {
                    fileKeys.push(row[glbPathKey]);
                } else if (!dwgUrl && hasDWG) {
                    fileKeys.push(row[dwgPathKey]);
                }
                // else if (hasOBJMTL) {
                //     if (!objUrl) {
                //         fileKeys.push(row[objPathKey]);
                //     }
                //     if (!mtlUrl) {
                //         fileKeys.push(row[mtlPathKey]);
                //     }
                //     if (row[texturePathKey] && Array.isArray(row[texturePathKey])) {
                //         const missingMeta = row[texturePathKey].filter((imgPath) => !metaData.some((url) => url.includes(imgPath)));
                //         if (missingMeta.length) {
                //             fileKeys.push(...missingMeta);
                //         }
                //     }
                // }
            }
            if (images?.length && !formattedImages.length) {
                const imageKeys = images.filter((_, i) => i !== 0).map((img) => img.path);
                if (imageKeys.length > 0) {
                    fileKeys.push(...imageKeys);
                } else if (row[primaryImageUrlKey]) {
                    formattedImages = [{ itemImageSrc: row[primaryImageUrlKey], thumbnailImageSrc: row[primaryImageUrlKey] }];
                }
            } else if (!has3D && !formattedImages.length && row[primaryImageUrlKey]) {
                formattedImages = [{ itemImageSrc: row[primaryImageUrlKey], thumbnailImageSrc: row[primaryImageUrlKey] }];
            }

            let downloadMap = {};
            if (fileKeys.length > 0) {
                const payload = {
                    serviceId,
                    fileKey: fileKeys,
                    source: "productCatalogue",
                };
                const res = await imagineHomeService.downloadMultipleMediaURL(payload);
                if (res?.download_url) {
                    downloadMap = res.download_url;
                }

                // Extract URLs
                if (hasGLB && downloadMap[row[glbPathKey]]) {
                    glbUrl = downloadMap[row[glbPathKey]];
                } else if (hasDWG && downloadMap[row[dwgPathKey]]) {
                    dwgUrl = downloadMap[row[dwgPathKey]];
                }
                // else if (hasOBJMTL && downloadMap[row[objPathKey]] && downloadMap[row[objPathKey]]) {
                //     objUrl = downloadMap[row[objPathKey]];
                //     mtlUrl = downloadMap[row[mtlPathKey]];
                //     if (row[texturePathKey] && Array.isArray(row[texturePathKey])) {
                //         metaData = row[texturePathKey].map((imgPath) => downloadMap[imgPath] || metaData.find((url) => url.includes(imgPath))).filter(Boolean);
                //     }
                // }

                if (images?.length && !cached?.formattedImages) {
                    const extraImages = images
                        .filter((_, i) => i !== 0)
                        .map((img) => downloadMap[img.path])
                        .filter(Boolean)
                        .map((url) => ({ itemImageSrc: url, thumbnailImageSrc: url }));

                    formattedImages = [{ itemImageSrc: row[primaryImageUrlKey], thumbnailImageSrc: row[primaryImageUrlKey] }, ...extraImages];
                }

                // Save new data in cache
                mediaCacheRef.current[productId] = { objUrl, mtlUrl, glbUrl, formattedImages, metaData };

                // API was called, update selectedProduct
                setSelectedProduct((prev) => ({
                    ...prev,
                    formattedImages,
                    objUrl,
                    mtlUrl,
                    glbUrl,
                    dwgUrl,
                    metaData,
                }));
            } else {
                //  API not called → still update from cache
                setSelectedProduct((prev) => ({
                    ...prev,
                    formattedImages,
                    objUrl,
                    mtlUrl,
                    glbUrl,
                    dwgUrl,
                    metaData,
                }));
            }

            setMediaDialogVisible(true);
        } catch (error) {
            console.error("Error fetching media:", error);
        } finally {
            setDownloadingMedia(false);
        }
    };

    return (
        <div className="col-12 grid  shadow-3 p-3 border-round align-items-center justify-content-between" style={{ fontFamily: "Inter", backgroundColor: "#FBF9F3" }}>
            <h2 className={` m-0 charcoal-color ${Object.keys(editRows).length !== 0 ? "lg:col-5" : "lg:col-5"} col-12`} style={{ whiteSpace: "nowrap", fontFamily: "Inter" }}>Product Catalog</h2>

            {/* Filters */}
            <div className={`flex flex-wrap gap-3 align-items-center  mb-3 lg:col-7 col-12`}>
                <div className="lg:col-5 col-12">
                    <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" style={{ color: "#6B7280" }} />
                        <InputText
                            value={item}
                            onChange={(e) => setItem(e.target.value)}
                            placeholder="Search By Item"
                            className="font-Gerstner-ProgramRegular w-full"
                            style={{
                                borderRadius: "20px",
                                boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                border: "1px solid #ddd",
                                 background: "white",
                                padding: "10px 12px 10px 40px",
                                fontSize: "14px",
                                fontFamily: "Inter",
                                height: "3rem",
                            }}
                        />
                        {item && (
                            <i
                                className="pi pi-times cursor-pointer"
                                style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#6B7280",
                                    fontSize: "14px"
                                }}
                                onClick={() => setItem("")}
                            />
                        )}
                    </span>
                </div>

                <div className="lg:col-5 col-12">
                    <Dropdown
                        value={vendor}
                        label="name"
                        options={vendorList}
                        onChange={(e) => setVendor(e.value)}
                        placeholder="Select Vendor"
                        className="font-Gerstner-ProgramRegular w-full"
                        style={{
                            borderRadius: "20px",
                            boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                            border: "1px solid #ddd",
                            background: "white",
                            height: "3rem",
                            fontSize: "14px",
                            fontFamily: "Inter"
                        }}
                    />
                </div>

                <div className="lg:col-1 col-6 ">
                    <Button
                        label=""
                        icon="pi pi-download"
                        onClick={exportToExcel}
                        className="p-button-primary w-full"
                        tooltip="Download"
                        style={{
                            background: "white",
                            height: "40px",
                            boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                            border: "1px solid #ddd",
                            color: "#3d3d3d",
                            borderRadius: "20px",
                            padding: "10px 20px",
                            whiteSpace: "nowrap"

                        }}
                        tooltipOptions={{ position: "bottom" }}
                    />
                </div>

                {admin ? (
                    <div className="lg:col-1 col-6">
                        <Button
                            label=""
                            icon="pi pi-plus"
                            onClick={() => history.push("/img-upload")}
                            className="p-button-primary w-full"
                            tooltip="Add Product Catalog"
                            tooltipOptions={{ position: "bottom" }}
                            style={{
                                    background: "white",
                                    height: "40px",
                                    boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                    border: "1px solid #ddd",
                                    color: "#3d3d3d",
                                    borderRadius: "20px",
                                    padding: "10px 20px",
                                    whiteSpace: "nowrap"

                                }}
                        />
                    </div>
                ) : null}
            </div>
            {/* <DataTable
                value={products}
                loading={loading}
                responsiveLayout="scroll"
                className="datatable-box w-full"
                paginator
                rows={rows}
                first={first}
                onPage={async (e) => {
                    const totalPages = Math.ceil(products.length / rows);
                    if (e.page === totalPages - 1 && skip !== -1) {
                        const newSkip = products.length;
                        setSkip(newSkip);
                        await handleFilter(newSkip);
                    }
                    setFirst(e.first);
                }}
            >
                <Column body={(row) => showData(row, "itemName")} header="Item Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "sku")} header="Sku" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "itemDesc")} header="Description" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "msrp")} header="Msrp" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "wholesalePrice")} header="Wholesale Price" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "map")} header="Map" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "upc")} header="Upc" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "color")} header="Color" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "width")} header="Width (in)" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "height")} header="Height (in)" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "depth")} header="Depth (in)" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "images")} header="Images/3D Model" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "vendor")} header="Vendor" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
            </DataTable> */}
            <DataTable
                value={products}
                loading={loading}
                responsiveLayout="scroll"
                className="w-full card-table"
                paginator
                rows={rows}
                rowClassName={() => 'card-row'}
                first={first}
                onPage={async (e) => {
                    const totalPages = Math.ceil(products.length / rows);
                    if (e.page === totalPages - 1 && skip !== -1) {
                        const newSkip = products.length;
                        setSkip(newSkip);
                        await handleFilter(newSkip);
                    }
                    setFirst(e.first);
                }}
            >
                <Column  style={{ minWidth: "250px" ,maxWidth:"250px"}} body={(row) => showData(row, "itemName")} header="Product Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => showData(row, "sku")} header="SKU" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => showData(row, "itemDesc")} header="Description" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => showData(row, "msrp")} header="Msrp" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                {/* <Column body={(row) => showData(row, "wholesalePrice")} header="Wholesale Price" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader"/> */}
                <Column body={(row) => showData(row, "map")} header="Map" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => showData(row, "upc")} header="Upc" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => showData(row, "color")} header="Color" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column body={(row) => {
                    return <p>{row["width"]}x{row["depth"]}x{row["height"]}</p>
                }} header={
                    <div className="flex flex-column justify-content-center align-items-center" style={{width:"180px"}}>
                        <span>Width x Depth x Height</span>
                        <span>(in)</span>
                    </div>
                } bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
                <Column
                    body={(row) => showData(row, "images")}
                    header={
                        <div className="flex flex-column">
                            <span>Images/</span>
                            <span style={{minWidth:"150px"}}>3D Model</span>
                        </div>
                    }
                    style={{ width: "250px" }}   // 👈 Increase width here
                    bodyClassName="text-md p-2 font-Gerstner-ProgramRegular"
                    headerClassName="dataTableHeader"
                />


                <Column body={(row) => showData(row, "vendor")} header="Vendor" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" />
            </DataTable>

            {mediaDialogVisible && (
                <Dialog
                    header={
                        <h3 className="m-0 font-light font-larken">{selectedProduct.itemName}</h3>

                        // <span className="font-larken font-semibold text-lg charcoal-color" style={{ fontSize: "2rem" }}>
                        //     {selectedProduct.itemName}
                        // </span>
                    }
                    visible={mediaDialogVisible}
                    style={{ width: "60vw", fontFamily: "Gerstner-ProgramRegular" }}
                    modal
                    onHide={() => setMediaDialogVisible(false)}
                >
                    {has3dModel() && selectedProduct.formattedImages?.length ? (
                        // Both images and 3D model → show tabs
                        <TabView>
                            <TabPanel header="Images">
                                <GalleryTemplate />
                            </TabPanel>

                            <TabPanel header="3D Model">
                                <ObjMtlViewer dwgUrl={selectedProduct.dwgUrl} glbUrl={selectedProduct.glbUrl} objUrl={selectedProduct.objUrl} mtlUrl={selectedProduct.mtlUrl} metaData={selectedProduct.metaData} width="100%" height="400px" />
                            </TabPanel>
                        </TabView>
                    ) : has3dModel() ? (
                        // Only 3D model
                        <ObjMtlViewer dwgUrl={selectedProduct.dwgUrl} glbUrl={selectedProduct.glbUrl} objUrl={selectedProduct.objUrl} mtlUrl={selectedProduct.mtlUrl} metaData={selectedProduct.metaData} width="100%" height="400px" />
                    ) : (
                        // Only images
                        <GalleryTemplate />
                    )}
                </Dialog>
            )}
        </div>
    );
};
//     "sku_media/3D_model/6000-0966_Lowpoly_tree_sample.mtl": "https://nq-aws-dev-imagine-homes-product-catalogue-bucket.s3.amazonaws.com/sku_media/3D_model/6000-0966_Lowpoly_tree_sample.mtl?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA445CY2R2UC6EFFHJ%2F20250822%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250822T065840Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=a8a38f9c7d1b67d3a4fd4e867ba293a3c9285af22a1a0373b2e57ec17390b94c",
// "sku_media/3D_model/6000-0966_Lowpoly_tree_sample.obj": "https://nq-aws-dev-imagine-homes-product-catalogue-bucket.s3.amazonaws.com/sku_media/3D_model/6000-0966_Lowpoly_tree_sample.obj?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA445CY2R2UC6EFFHJ%2F20250822%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250822T065840Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=4b49b642b519168dd89cc45fcf22283d7401c9135390cbe816b109c316a03a5e"
export default ProductCatalogue;
